import Request from "./request";
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'
// 当前库存
async function fetch(data) {
  return Request("get", "api/stock-currents/", data);
}
async function fetchOne(id,data) {// 获取单个
    return Request('get', "api/stock-currents/" + id, data);
}
// 导出当前库存报表
async function exports(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-currents/export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

// 导出当前分仓库存报表
async function allStockExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/StockCurrents/allStockExport', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

// 导出当前分仓库存报表
async function sheetExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/StockCurrents/sheetExport', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

export default {
  fetch,
  fetchOne,
  exports,
  allStockExport,
  sheetExport,
};
